module.exports = __webpack_public_path__ + "img/mastercard.ef4afb4.png";